import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { Router } from "@angular/router";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { AppControllerService } from "../../../app-controller.service";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DisclaimerDialogBodyComponent } from "../../../core/dashboard/disclaimer-dialog-body/disclaimer-dialog-body.component";
import { RolesEnum } from "../../../core/organisations/shared/models/organisation-heading-enum";
import { AuthService } from "../auth/auth.service";
import { ApiUserConstants } from "../../constants/api-constants/api-user.constants";
import { skip, take } from "rxjs/operators";
import { SystemSettingService } from "../system-setting/system-setting.service";
export const ANONYMOUS_USER = {
    email: "",
    firstName: "",
    id: undefined,
    lastName: "",
    // modules: [],
    organisationApplications: [],
    organisations: [],
    userId: "",
    phoneNumber: "",
};
let UserInformationService = class UserInformationService {
    http;
    router;
    appControllerService;
    matDialog;
    authService;
    systemSettingsService;
    adminModulesSubject = new BehaviorSubject(null);
    $adminModules = this.adminModulesSubject.asObservable();
    systemOrganisationsSubject = new BehaviorSubject(null);
    $systemOrganisations = this.systemOrganisationsSubject.asObservable();
    systemModulesSubject = new BehaviorSubject([]);
    $systemModules = this.systemModulesSubject.asObservable();
    userInformationFetchedSubject = new BehaviorSubject(false);
    $userInformationFetched = this.userInformationFetchedSubject.asObservable();
    authenticatedUserSubject = new BehaviorSubject(ANONYMOUS_USER);
    $authenticatedUser = this.authenticatedUserSubject.asObservable();
    $isAuthenticated;
    showDisclaimerAfterCreateOrganisation = true;
    constructor(http, router, appControllerService, matDialog, authService, systemSettingsService) {
        this.http = http;
        this.router = router;
        this.appControllerService = appControllerService;
        this.matDialog = matDialog;
        this.authService = authService;
        this.systemSettingsService = systemSettingsService;
        this.$isAuthenticated = this.authService.$isAuthenticated;
        this.setUpListeners();
    }
    get userInformationFetchedValue() {
        return this.userInformationFetchedSubject.value;
    }
    get authenticatedUser() {
        return this.authenticatedUserSubject.getValue();
    }
    getUserInformation() {
        this.getUserInformationRequest().pipe(take(1))
            .subscribe({
            next: (userInformation) => {
                const moduleIds = [];
                const organisationIds = [];
                userInformation.organisations.forEach(org => {
                    organisationIds.push(org.id);
                    org.modules.forEach(mod => {
                        mod.userModuleRoles = [];
                        moduleIds.push(mod.id);
                    });
                });
                const organisationParams = {
                    organisationIds
                };
                this.getMyOrganisationRolesRequest(organisationParams)
                    .pipe(take(1))
                    .subscribe({
                    next: (organisationRoles) => {
                        userInformation.organisations.forEach(org => {
                            org.userSystemRoles = [];
                            organisationRoles.roles.forEach(role => {
                                if (role.organisationId === org.id) {
                                    org.userSystemRoles.push(role);
                                }
                            });
                        });
                        const moduleParams = {
                            moduleIds
                        };
                        this.getMyModuleRolesRequest(moduleParams)
                            .pipe(take(1))
                            .subscribe({
                            next: (roles) => {
                                userInformation.organisations.forEach(org => org.modules.forEach(mod => {
                                    mod.userModuleRoles = [];
                                    roles.roles.forEach(role => {
                                        if (role.moduleId === mod.id) {
                                            mod.userModuleRoles.push(role);
                                        }
                                    });
                                }));
                                this.handleUserInformation(userInformation);
                                this.systemSettingsService.loadSettings().then(data => {
                                    if (this.systemSettingsService.isMaintenanceModeEnabled() && !this.systemSettingsService.getMaintenanceAcknowledged() && !this.router.url.includes("/logout")) {
                                        this.router.navigateByUrl(`/${AppRoutingConstants.MAINTENANCE_PATH}`);
                                    }
                                });
                            },
                            error: (error) => {
                                this.appControllerService.handleServerErrorMessage("user information", error, CRUDOperation.Get);
                            }
                        });
                    },
                    error: (error) => {
                        this.appControllerService.handleServerErrorMessage("user information", error, CRUDOperation.Get);
                    }
                });
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage("user information", error, CRUDOperation.Get);
            }
        });
    }
    getModuleInformation(moduleId) {
        let foundModule;
        this.getSystemModules()?.forEach((module) => {
            if (module.id === moduleId) {
                foundModule = module;
                return;
            }
        });
        return foundModule;
    }
    getOrganisationInformation(OrganisationId) {
        let foundOrganisation = null;
        this.getOrganisations().forEach((organisation) => {
            if (organisation.id === OrganisationId) {
                foundOrganisation = organisation;
            }
        });
        return foundOrganisation;
    }
    getOrganisationId(moduleId) {
        const module = this.getModuleInformation(moduleId);
        if (module) {
            return module.organisationId;
        }
        else {
            return null;
        }
    }
    updateModules(modules) {
        this.systemModulesSubject.next(modules);
    }
    isModuleAdmin(moduleId) {
        if (this.isSysadminAdmin()) {
            return true;
        }
        let module = null;
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.getSystemModules().length; i++) {
            const mod = this.getSystemModules()[i];
            if (mod.id === moduleId) {
                module = mod;
                break;
            }
        }
        if (module !== null) {
            if (this.isOrganisationAdmin(module.id)) {
                return true;
            }
            return module?.userModuleRoles?.some(role => role.role === RolesEnum.ModuleAdmin);
        }
        else {
            return false;
        }
    }
    isOrganisationAdmin(organisationId) {
        let result = false;
        if (this.isSysadminAdmin()) {
            return true;
        }
        else if (this.isOrganisationSuperAdmin(organisationId)) {
            return true;
        }
        for (const organisation of this.authenticatedUserSubject.value.organisations) {
            if (organisation.id === organisationId) {
                organisation.userSystemRoles.some(userSystemRole => {
                    if (userSystemRole.role === RolesEnum.OrganisationAdmin) {
                        result = true;
                    }
                });
            }
        }
        return result;
    }
    isOrganisationSuperAdmin(organisationId) {
        let result = false;
        if (this.isSysadminAdmin()) {
            return true;
        }
        this.authenticatedUserSubject.value?.organisations.forEach((organisation) => {
            if (organisation.id === organisationId) {
                organisation.userSystemRoles.some(userSystemRole => {
                    if (userSystemRole.role === RolesEnum.SuperAdmin) {
                        result = true;
                    }
                });
            }
        });
        return result;
    }
    isAnyOrganisationSuperAdmin() {
        let result = false;
        if (this.isSysadminAdmin()) {
            return true;
        }
        this.authenticatedUserSubject.value?.organisations.forEach((organisation) => {
            organisation.userSystemRoles.some(userSystemRole => {
                if (userSystemRole.role === RolesEnum.SuperAdmin) {
                    result = true;
                }
            });
        });
        return result;
    }
    isSysadminAdmin() {
        return this.authenticatedUserSubject.value?.isSysAdmin;
    }
    getUserInformationRequest() {
        const params = {
            $expand: `Organisations($expand=Settings,Modules),OrganisationApplications`
        };
        return this.http.get(`${ApiUserConstants.URL}/${ApiUserConstants.FUNCTION_GET_MY_INFORMATION}`, { params });
    }
    refreshUserInformation() {
        this.getUserInformation();
        return this.$authenticatedUser.pipe(skip(1), take(1));
    }
    getMyModuleRolesRequest(params) {
        return this.http.post(`${ApiUserConstants.URL}/${ApiUserConstants.FUNCTION_GET_MY_MODULE_ROLES}`, params);
    }
    getMyOrganisationRolesRequest(params) {
        return this.http.post(`${ApiUserConstants.URL}/${ApiUserConstants.FUNCTION_GET_MY_ORGANISATION_ROLES}`, params);
    }
    getUserById(params, userId) {
        return this.http.get(`${ApiUserConstants.URL}/${userId}`, { params });
    }
    publishAuthUserValue(value) {
        this.authenticatedUserSubject.next(value);
        this.userInformationFetchedSubject.next(true);
    }
    publishSystemModules(user) {
        if (user) {
            const modules = [];
            user.organisations.forEach(organisation => {
                if (!organisation.suspended) {
                    const filteredOrgModules = organisation.modules.filter(orgModule => !orgModule.suspended);
                    filteredOrgModules.forEach((module) => {
                        module.organisation = organisation;
                    });
                    modules.push(...filteredOrgModules);
                }
            });
            this.systemModulesSubject.next(modules.sort((a, b) => 0 - (a.name > b.name ? -1 : 1)));
        }
        else {
            this.systemModulesSubject.next([]);
        }
    }
    publishAdminModules(user) {
        const modules = [];
        user.organisations.forEach(organisation => {
            organisation.modules.forEach(module => {
                const isAdmin = module.userModuleRoles.some(role => role.role === "Admin");
                if (isAdmin) {
                    modules.push(module);
                }
            });
        });
        this.adminModulesSubject.next(modules);
    }
    publishSystemOrganisations(user) {
        const organisations = [];
        if (user) {
            organisations.push(...user.organisations);
            this.systemOrganisationsSubject.next(organisations.sort((a, b) => 0 - (a.name > b.name ? -1 : 1)));
        }
        else {
            this.systemOrganisationsSubject.next([]);
        }
    }
    getSystemModules() {
        return this.systemModulesSubject.value;
    }
    handleUserInformation(userInfo) {
        this.publishAuthUserValue(userInfo);
        this.publishAdminModules(userInfo);
        this.publishSystemModules(userInfo);
        this.publishSystemOrganisations(userInfo);
        this.handleOrganisationInfo(userInfo);
        if (this.systemSettingsService.isMaintenanceModeEnabled() && !this.systemSettingsService.getMaintenanceAcknowledged() && !this.router.url.includes("/logout")) {
            this.router.navigateByUrl(`/${AppRoutingConstants.MAINTENANCE_PATH}`);
        }
    }
    setUpListeners() {
        this.setupAuthenticationListener();
    }
    showDisclaimer() {
        if (this.matDialog.openDialogs.length === 0) // this can be useful to remove multiple opening dialogs
         {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            localStorage.setItem("showDisclaimer", "false");
            this.matDialog.open(DisclaimerDialogBodyComponent, dialogConfig);
        }
    }
    applyForAccess() {
        this.router
            .navigate([AppRoutingConstants.createRouteToViewWithPrefixRouteSeparator(AppRoutingConstants.ORGANISATION_APPLY_ACCESS_ROUTE)]);
    }
    handleOrganisationInfo(userInfo) {
        if (this.showDisclaimerAfterCreateOrganisation) {
            if (userInfo.organisations.length > 0) {
                const showDisclaimer = localStorage.getItem("showDisclaimer");
                if (!showDisclaimer) {
                    this.showDisclaimer();
                }
            }
            else {
                this.applyForAccess();
            }
        }
        else {
            this.showDisclaimerAfterCreateOrganisation = true;
        }
    }
    setupAuthenticationListener() {
        this.$isAuthenticated.subscribe((isAuthenticated) => {
            if (isAuthenticated) {
                this.getUserInformation();
            }
        });
    }
    getOrganisations() {
        return this.systemOrganisationsSubject.value;
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: Router },
        { type: AppControllerService },
        { type: MatDialog },
        { type: AuthService },
        { type: SystemSettingService }
    ];
};
UserInformationService = __decorate([
    Injectable({
        providedIn: "root"
    })
], UserInformationService);
export { UserInformationService };
